const extraStyle = {
  buttonStyle: '',
  variant: 'primary'
};
export default extraStyle;
